module.exports = __webpack_public_path__ + "static/media/Subscribde.069b6563.svg";